import React from 'react';
import Story from '../components/Story';
import ClubNow from '../components/ClubNow';
import Board from '../components/Board';
import Lab from '../components/Lab';

export default function Club() {
  return (
    <>
      <Story />
      <ClubNow />
      <Board />
      <Lab />
    </>
  );
}
